"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = ["title"];
const _hoisted_2 = ["title"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_language_selection_dialog = (0, vue_1.resolveComponent)("language-selection-dialog");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
        class: "sidebar_item sidebar_item--language",
        title: _ctx.$t('Language')
    }, [
        (0, vue_1.createElementVNode)("div", {
            class: (0, vue_1.normalizeClass)(["sidebar_icon sidebar_icon--language", { 'sidebar_item--is-active': _ctx.languagePanelOpen }])
        }, [
            (0, vue_1.createElementVNode)("div", {
                class: (0, vue_1.normalizeClass)(`language-icon language-icon-for-sidebar language-icon--${_ctx.lang}`),
                title: _ctx.title,
                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.languagePanelOpen = !_ctx.languagePanelOpen))
            }, null, 10, _hoisted_2)
        ], 2),
        (0, vue_1.withDirectives)((0, vue_1.createVNode)(_component_language_selection_dialog, { preferencesManager: _ctx.preferencesManager }, null, 8, ["preferencesManager"]), [
            [vue_1.vShow, _ctx.languagePanelOpen]
        ])
    ], 8, _hoisted_1));
}
